var map = {
	"./address_image.svg": 91,
	"./animated_logo.svg": 92,
	"./avatar.png": 93,
	"./badges.png": 94,
	"./blogs_image.svg": 95,
	"./cloud_infrastructure.svg": 96,
	"./code.png": 97,
	"./codeInLogo.png": 98,
	"./contactMail.png": 99,
	"./coursera_logo.png": 100,
	"./data_science.svg": 101,
	"./dataverse.jpeg": 102,
	"./deeplearning_ai_logo.png": 103,
	"./delhivery_logo.png": 104,
	"./developerActivity.svg": 105,
	"./dsc_logo.png": 106,
	"./education.svg": 107,
	"./experience.svg": 108,
	"./feelingProud.svg": 109,
	"./freecopy_logo.png": 110,
	"./fullstack.svg": 111,
	"./gcp_logo.png": 112,
	"./github_logo.png": 113,
	"./googleAssistant.jpg": 114,
	"./googleAssistant.svg": 115,
	"./google_logo.png": 116,
	"./ibm_logo.png": 117,
	"./iiitk_logo.png": 118,
	"./intel_logo.jpg": 119,
	"./iu_logo.png": 120,
	"./jsFramework.svg": 121,
	"./lc100_1.png": 122,
	"./lc100_2.png": 123,
	"./lc50-1.png": 124,
	"./lc_dec.png": 125,
	"./lc_feb.png": 126,
	"./lc_jan.png": 127,
	"./lc_jun.png": 128,
	"./lc_nov.png": 129,
	"./lc_nov1.png": 130,
	"./lc_oct.png": 131,
	"./lc_sep.png": 132,
	"./leetcode_streak.png": 133,
	"./legato_logo.png": 134,
	"./lg50-2.png": 135,
	"./manOnTable.svg": 136,
	"./microsoft_logo.png": 137,
	"./mozilla_logo.png": 138,
	"./muffito_logo.png": 139,
	"./nextuLogo.jpg": 140,
	"./nptel_logo.png": 141,
	"./portfolio.gif": 142,
	"./programmer.svg": 143,
	"./projects_image.svg": 144,
	"./pwa.png": 145,
	"./saayaHealthLogo.png": 146,
	"./stanford_logo.png": 147,
	"./talksCardBack.svg": 148,
	"./talksCardBackAlt.svg": 149,
	"./tiktok_logo.png": 150,
	"./tr.png": 151,
	"./ts.png": 152,
	"./ub.png": 153,
	"./ub1-removebg-preview.png": 154,
	"./ub1.png": 155,
	"./ub2.png": 156,
	"./ui_ux_design.svg": 157,
	"./vnr.jpg": 158,
	"./vnr1.png": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;